import { useEffect, useState } from 'react';
import { marked } from 'marked';
import styled from 'styled-components';
import { removeScript } from 'utils/script';
import { borderWidth2, spacing } from 'ui/theme';

export const MarkdownWrapper = styled.div`
  blockquote {
    margin-left: 0;
    padding: 0 0 0 ${spacing.plusQuarter};
    border-left: ${borderWidth2};
  }
  code {
    font-family: Menlo, Monaco, Consolas, 'Lucida Console', monospace;
  }
`;

type MarkdownProps = {
  id: string;
  'data-test'?: string;
  markdownText: string;
  Wrapper?: React.FC;
};

export const Markdown = ({
  id,
  'data-test': dataTest,
  markdownText,
  Wrapper,
  ...props
}: MarkdownProps) => {
  const [markdownHtml, setMarkdownHtml] = useState('');

  const WrapperCmp = Wrapper ?? MarkdownWrapper;

  useEffect(() => {
    setMarkdownHtml(marked.parse(markdownText).toString());
  }, [markdownText]);
  return (
    <WrapperCmp {...props}>
      <div
        data-test={dataTest ?? `markdown-${id}`}
        dangerouslySetInnerHTML={{ __html: removeScript(markdownHtml) }}
      />
    </WrapperCmp>
  );
};
